import { render } from "./Section6.vue?vue&type=template&id=f7aa558a&scoped=true"
import script from "./Section6.vue?vue&type=script&lang=js"
export * from "./Section6.vue?vue&type=script&lang=js"

import "./Section6.vue?vue&type=style&index=0&id=f7aa558a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7aa558a"]])

export default __exports__